import { render, staticRenderFns } from "./OpenSwitch.vue?vue&type=template&id=138fbe3a&"
import script from "./OpenSwitch.vue?vue&type=script&lang=js&"
export * from "./OpenSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports